// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"718":"cebe99d3","766":"5a744f91","986":"347aeda6"}[chunkId] + ".js";
};